import { RefObject } from 'react';
import { CropperRef } from './croppModal';

/* eslint-disable no-unused-vars */
export default class CropperConnector {
  public cropRef: RefObject<CropperRef>;

  constructor(cropRef: RefObject<CropperRef>) {
    this.cropRef = cropRef;
  }

  // Called by FilePond to edit the image
  // - should open your image editor
  // - receives file object and image edit instructions
  public open(file: File) {
    if (this.cropRef.current) {
      this.cropRef.current.open(file);
    }
  }

  // Callback set by FilePond
  // - should be called by the editor when user confirms editing
  // - should receive output object, resulting edit information
  public onconfirm() {}

  // Callback set by FilePond
  // - should be called by the editor when user cancels editing
  public oncancel() {}

  // Callback set by FilePond
  // - should be called by the editor when user closes the editor
  public onclose() {}
}
